<app-menu>
    <div class="header">
        <div class="header-title">
            <div class="title">Carrier Delivery Report</div>
            <div class="other-pages">
                <!-- styles are inline because of specificity issues when using classes with Angular Material properties-->
                <button mat-raised-button style="background-color:#3f51b5;color:white;margin-right:20px" (click)="openDeliveryReports()">Delivery Report</button>
                <button mat-raised-button style="background-color:#3f51b5;color:white;margin-right:20px" (click)="openStoreReports()">Store Report</button>
                <button mat-raised-button style="background-color:#3f51b5;color:white" (click)="openExceptionReports()">Exception Report</button>
            </div>
        </div>
        <div class="header-btns">
            <mat-button-toggle-group value="date" (change)="onToggleFilterChange($event)" #filterGroup="matButtonToggleGroup">
                <mat-button-toggle value="date">Filter by Date</mat-button-toggle>
                <mat-button-toggle value="week">Filter by Week No.</mat-button-toggle>
            </mat-button-toggle-group>
            <button (click)="toggleTheme()" class="header-btn toggle-grid-mode-btn">
                <mat-icon>{{themeClass === 'ag-theme-ulaap' ? 'nights_stay' : 'wb_sunny'}}</mat-icon>
            </button>
        </div>
        <div class="reports-form" [formGroup]="reports_form">
            <mat-form-field *ngIf="filterGroup.value == 'date'" class="filter-input">
                <mat-label>Date (From):</mat-label>
                <input matInput formControlName="date_from" [matDatepicker]="dateFromPicker">
                <mat-datepicker-toggle matIconSuffix [for]="dateFromPicker"></mat-datepicker-toggle>
                <mat-datepicker #dateFromPicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field *ngIf="filterGroup.value == 'date'" class="filter-input">
                <mat-label>Date (To):</mat-label>
                <input matInput formControlName="date_to" [matDatepicker]="dateToPicker">
                <mat-datepicker-toggle matIconSuffix [for]="dateToPicker"></mat-datepicker-toggle>
                <mat-datepicker #dateToPicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field *ngIf="filterGroup.value == 'week'" class="filter-input">
                <mat-label>Week (From):</mat-label>
                <input matInput formControlName="week_from" placeholder="Type a number"/>
            </mat-form-field>
            <mat-form-field *ngIf="filterGroup.value == 'week'" class="filter-input">
                <mat-label>Week (To):</mat-label>
                <input matInput formControlName="week_to" placeholder="Type a number"/>
            </mat-form-field>
            <button mat-raised-button (click)="search()" style="background-color:#3f51b5; color: white"><i class="fa-solid fa-magnifying-glass"></i>                                                                                                                                                                                                                                                                                                       Search</button>
            <button mat-raised-button (click)="resetFilters()" style="background-color:#3f51b5; color: white">Reset</button>
        </div>
        <div class="export-btns">
            <button (click)="exportToCSV()" mat-raised-button style="background-color:#3f51b5;color:white;margin-right:20px">Export to CSV</button>
            <button (click)="exportToExcel()" mat-raised-button style="background-color:#3f51b5;color:white">Export to Excel</button>
        </div>
    </div>
    <ag-grid-angular
    style="width: 100%; height: 76%"
    [rowModelType]="rowModelType"
    [cacheBlockSize]="cacheBlockSize"
    [cacheOverflowSize]="cacheOverflowSize"
    [maxConcurrentDatasourceRequests]="maxConcurrentDatasourceRequests"
    [class]="themeClass"
    [rowData]="rowData"
    [gridOptions]="gridOptions"
    (gridReady)="onGridReady($event)"
    [defaultColDef]="defaultColDef"
    [columnDefs]="columnDefs"
    >
    </ag-grid-angular>
</app-menu>